"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Tourtip {
    handleCollapse({ originalEvent }) {
        if (this.state.expanded) {
            this.state.expanded = false;
            this.emit("collapse", { originalEvent });
        }
    }
    handleExpand({ originalEvent }) {
        if (!this.state.expanded) {
            this.state.expanded = true;
            this.emit("expand", { originalEvent });
        }
    }
    onInput(input) {
        if (input.open === false || input.open === true) {
            this.state.expanded = input.open;
        }
    }
    onCreate() {
        this.state = {
            expanded: false,
        };
    }
    handleLoaded() {
        // This is only done to prevent a blink when loading floating ui library
        if (this.input.open !== false) {
            this.state.expanded = true;
        }
        this.emit("loaded");
    }
}
module.exports = Tourtip;
